module.exports = __webpack_public_path__ + "static/img/focusCode.57935d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/fixed/focusCode.png
// module id = 5G6a
// module chunks = 22